import { render } from "./AboutApp.vue?vue&type=template&id=7b5cf8b8"
import script from "./AboutApp.vue?vue&type=script&lang=js"
export * from "./AboutApp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__